import React, { Component } from 'react'
import './index.css'
import BlogImageURL from '../../media/image/blogimage.png'
import RencentPosts from '../RecentPosts'
import { TfiTimer } from "react-icons/tfi";
import { GoPerson } from "react-icons/go";
import PageRoute from '../PageRoute';
import PubSub from 'pubsub-js';
export default class PolicyPage extends Component {
    componentDidMount(){
        window.scrollTo({top:0,behavior:"auto"})
        PubSub.publish('routes',[
            {pathname:'/acer/policy',name:"Policy",isCurrent:true},
        ])
    }
  render() {
    return (
      <div className='blogpage'>
        <PageRoute/>
        <div className='blogpage-content'>
            <h1 className='blogpage-title'>Return & Refund Policy for All the Product</h1>
            <div className='blogpage-subcontent'>
                <h3>Refund Period</h3>
                <li>Returns accepted within 14 days from the date your online order is delivered.</li>
            </div>
            <div className='blogpage-subcontent'>
                <h3>Eligibility</h3>
                <li>Products must be in their original condition, including all packaging, accessories and proof of purchase.</li>
                <li>Damaged, physically altered or incomplete items are not eligible for refunds.</li>
            </div>
            <div className='blogpage-subcontent'>
                <h3>Refund Processing</h3>
                <li>Refund will be issued to the original method of payment once the item has been inspected and approved.</li>
                <li>Please allow up to 5-10 business days for refund processing.</li>
            </div>
            <div className='blogpage-subcontent'>
                <h3>What You Must Provide:</h3>
                <p>To initiate a return, you must include:</p>
                <li>The original receipt or invoice.</li>
                <li>The original payment method (refunds will be issued via the same card or method used).</li>
                <li>Original packaging and all included items.</li>
                <li>Your name, address, phone number. A valid government-issued photo ID may be required to verify your identity.</li>
            </div>
            <div className='blogpage-subcontent'>
                <h3>Final Sale Items</h3>
                <li>Items marked as “Final Sale” at the time of purchase are not eligible for return or refund.</li>
            </div>
            <div className='blogpage-subcontent'>
                <h2>How to Return Your Product</h2>
                <h3>By Mail</h3>
                <li style={{listStyle:"decimal"}}>Contact our customer service to obtain a return authorization.</li>
                <li style={{listStyle:"decimal"}}>We’ll email you a pre-paid shipping label.</li>
                <li style={{listStyle:"decimal"}}>Print and securely attach the label to the original box. Remove or cover any prior labels.</li>
                <li style={{listStyle:"decimal"}}>Drop the package off at the designated courier.</li>
                <li style={{listStyle:"decimal"}}>Once we receive and inspected the product, your refund will be processed.</li>
            </div>
            <div className='blogpage-subcontent'>
                <h3>Additional Notes</h3>
                <li>We reserve the right to refuse a refund if the return does not meet the above conditions.</li>
            </div>
            
        </div>
      </div>
    )
  }
}
